// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"ec0dbae7","49":"2a8ad05f","92":"b274a1a9","453":"1711b386","617":"7ac3140d","755":"9992231b"}[chunkId] + ".chunk.js";
};